<template>
  <section>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h1 class="title mr-3">{{ $t('entity.logging') }}</h1>
      <div class="d-flex align-items-center">
        <logging-filter :dates="dates" @confirm="confirmFilter"></logging-filter>
      </div>
    </div>

    <base-table :no-data="!hasLoggs" :headers="headers" :loading="loading">
      <template #tbody>
        <logging-table-row v-for="logItem in loggs" :key="logItem.id" :logItem="logItem"></logging-table-row>
      </template>
    </base-table>
    <div class="mt-3">
      <paginator
        v-if="showPaginator"
        :total="totalCount"
        :per-page="perPage"
        v-model="currentPage"
        @change:count="numberOfElements"
      ></paginator>
    </div>
  </section>
</template>

<script>
import http from '@/modules/http.js'
import { stringify } from 'qs'
import { paginator } from '@/mixins/paginator.js'
import { DATE_FORMAT } from '@/main.config.js'

export default {
  name: 'LoggingPage',
  mixins: [paginator],
  components: {
    BaseTable: () => import('@/base/BaseTable.vue'),
    LoggingTableRow: () => import('@/components/table-rows/LoggingTableRow.vue'),
    LoggingFilter: () => import('@/components/Filters/PageLoggingFilter.vue')
  },
  data: () => ({
    loading: true,
    totalCount: null,
    loggs: null,
    total: null,
    limit: 10,
    offset: null,
    method: null,
    entity: null,
    dates: null,
    userId: null
  }),
  validations() {},
  created() {
    this.loadData()
  },
  mounted() {},
  computed: {
    hasFilterRange() {
      return this.dates && this.dates.startDate && this.dates.endDate
    },
    params() {
      let params = Object.assign({}, this.pageParams)
      params['$sort'] = {
        createdAt: -1
      }
      params['entity_name'] = {
        ['$ne']: 'authentication'
      }
      if (this.method) {
        params['action'] = {
          $like: `%${this.method}`
        }
      }
      if (this.entity) {
        params['entity_name'] = {
          $like: `%${this.entity}`
        }
      } else {
        params['entity_name'] = {
          ['$ne']: 'authentication'
        }
      }
      if (this.userId) {
        params['user_id'] = this.userId
      }
      if (this.hasFilterRange) {
        const dateEnd = this.dates.endDate.clone().add(1, 'day')
        params['createdAt'] = {
          $gte: this.dates.startDate.format(DATE_FORMAT.serverFull),
          $lte: dateEnd.format(DATE_FORMAT.serverFull)
        }
      }

      return params
    },
    hasLoggs() {
      return this.loggs && this.loggs.length > 0
    },
    headers() {
      return {
        user_id: {
          title: this.$t('logging.userId'),
          class: 'th-name'
          //sorting: 'asc'
        },
        entity: {
          title: 'URL',
          class: 'th-event'
          //sorting: 'asc'
        },
        action: {
          title: this.$t('logging.method')
        },
        action_data: {
          title: this.$t('logging.valueAfterChange')
        },
        old_data: {
          title: this.$t('logging.valueBeforeChange')
        },
        createdAt: {
          title: this.$t('logging.dateTime')
        }
      }
    }
  },
  methods: {
    loadData() {
      this.loading = true

      http
        .get('/audit_logs', {
          params: this.params,
          paramsSerializer: params => stringify(params, { arrayFormat: 'brackets' })
        })
        .then(response => response.data)
        .then(data => {
          this.totalCount = data.total
          this.loggs = data.data
        })
        .catch(error => console.error(error))
        .finally(() => (this.loading = false))
    },
    numberOfElements(number) {
      this.perPage = number
    },
    confirmFilter(data) {
      this.method = data.method
      this.entity = data.entity
      this.userId = data.userId
      this.dates = data.dates
      this.loadData()
    }
  }
}
</script>
